(function () {
  var WISHLIST_KEY = 'balli_wishlist';

  function getWishlistCount() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      if (!raw) return 0;
      var list = JSON.parse(raw);
      return Array.isArray(list) ? list.length : 0;
    } catch (e) {
      return 0;
    }
  }

  function updateWishlistBadge() {
    var el = document.querySelector('[data-balli-wishlist-count]');
    if (el) el.textContent = String(getWishlistCount());
  }

  function updateCartBadge(count) {
    var el = document.querySelector('[data-balli-cart-count]');
    if (!el) return;
    if (typeof count === 'number') {
      el.textContent = String(count);
      return;
    }
    var headerBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    el.textContent = headerBubble ? headerBubble.textContent.trim() : '0';
  }

  function openCart() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    // Open the drawer directly. Re-clicking the header icon sent a second click through
    // every tracking script's click listener, doubling the work behind each tap.
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(cartIcon);
      return;
    }
    if (cartIcon) {
      cartIcon.click();
      return;
    }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function openSearch() {
    var summary = document.querySelector('.header__search summary, details-modal.header__search summary');
    if (summary) {
      summary.click();
      return;
    }
    window.location.href = '/search';
  }

  function init() {
    var nav = document.getElementById('BalliMobNav');
    if (!nav) return;

    document.body.classList.add('has-balli-mobnav');
    updateWishlistBadge();
    updateCartBadge();

    nav.addEventListener('click', function (e) {
      var cartBtn = e.target.closest('[data-balli-mobnav="cart"]');
      var searchBtn = e.target.closest('[data-balli-mobnav="search"]');
      if (cartBtn) {
        e.preventDefault();
        openCart();
      }
      if (searchBtn) {
        e.preventDefault();
        // Already open: this tap reaching the page closes it, like any tap outside it.
        if (document.querySelector('details-modal.header__search details[open]')) return;
        // Open after this tap finishes: the search modal closes on any body click outside
        // it, and opening it synchronously let this same tap bubble up and close it again.
        setTimeout(openSearch);
      }
    });

    window.addEventListener('storage', function (ev) {
      if (ev.key === WISHLIST_KEY) updateWishlistBadge();
    });

    document.addEventListener('balli:wishlist-updated', updateWishlistBadge);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.item_count === 'number') {
          updateCartBadge(event.cartData.item_count);
        } else {
          updateCartBadge();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
